import type CharmSuggestionsViewState from '../store/schema/CharmSuggestionsViewState';

export default function createCharmSuggestionsViewState(): CharmSuggestionsViewState {
    return {
        highlightedIndex: 0,
        shouldShowSuggestions: false,
        suggestions: [],
    };
}
